/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowLeft: {
  name: 'arrow-left';
  data: string;
} = {
  name: 'arrow-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m14 7-5 5 5 5V7z"/></svg>`
};
